import React, { createContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export const FulfillmentPodContext = createContext();

export const FulfillmentPod = (
  {
    children = null,
    className = null,
    hideStoreNameLink = false
  }
) => {
  return (
    <FulfillmentPodContext.Provider value={{ className, hideStoreNameLink }}>
      <div className={classNames('grid', className)} data-component="FulfillmentPod">
        {children}
      </div>
    </FulfillmentPodContext.Provider>
  );
};

FulfillmentPod.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  className: PropTypes.string,
  hideStoreNameLink: PropTypes.bool
};
